export class LoadPlanogramRequest{
    planogramId : string = '';
    stateId : string | null = null;
    constructor(planogramId : string, stateId : string | null){
        this.planogramId = planogramId;
        this.stateId = stateId;
    }
}

